import React from "react";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/legalPage.scss";

/**
 * LegalContent — shared shell for Terms & Conditions and Privacy Policy
 * Figma: screens 25 (T&C) & 26 (Privacy Policy) from T2 design pack
 *
 * Layout: Navbar → centered content card (title + sections) → Footer
 * The `sections` prop is an array of { heading?, paragraphs[] } blocks.
 */

const LegalContent = ({ title, sections }) => {
  console.log("[LegalContent] render:", { title, sectionCount: sections?.length });

  return (
    <div className="legal-page">
      <Navbar activeTab="" />

      <div className="legal-page__body">
        <div className="legal-page__card">
          <h1 className="legal-page__title">{title}</h1>

          {sections.map((section, idx) => (
            <div key={idx} className="legal-page__section">
              {section.heading && (
                <p className="legal-page__section-heading">{section.heading}</p>
              )}
              {section.paragraphs.map((para, pIdx) => (
                <p key={pIdx} className="legal-page__paragraph">
                  {para}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default LegalContent;
